"use client";

import { env } from "@/env";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";

export function PostHogProvider({ children, userId }: { children: React.ReactNode; userId?: string }) {
  useEffect(() => {
    posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
      defaults: "2026-01-30",
      autocapture: {
        dom_event_allowlist: [], // Disable
        element_allowlist: [], // Disable
        capture_copied_text: false
      }
    });
  }, []);

  useEffect(() => {
    if (userId) {
      posthog.identify(userId);
    }
  }, [userId]);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
